<template lang="pug">
.social-media-buttons
    a.button.calendar(target="_blank" :href="urls.calendar")
        font-awesome-icon(icon="calendar")
        span Termine
    a.button.facebook(target="_blank" :href="urls.fb")
        font-awesome-icon(:icon="['fab', 'facebook-f']")
</template>
<script>
//import Components

export default {
    name: "SocialMedia",
    data() {
        return {
            facebookLink: {
                angelverein: 'https://www.facebook.com/angelvereinkempen/',
            },
            calendarLink: {
                angelverein: 'https://www.angelverein-kempen.de/termine'
            }
        }
    },
    computed: {
        baseUrl() {
            return window.location.host
        },
        urls() {
            switch (this.baseUrl) {
                case 'angelverein-kempen.de.37-61-201-233.vanameland05.de':
                case 'angelverein-kempen.de':
                case 'www.angelverein-kempen.de':
                    return {calendar: this.calendarLink.angelverein, fb: this.facebookLink.angelverein}
                default:
                    return {calendar: 'https://angelverein-kempen.de', fb: 'https://angelverein-kempen.de', twitter: 'https://angelverein-kempen.de', instagram: 'https://angelverein-kempen.de'}
            }
        }
    }
}
</script>
<style lang="sass" scoped>
@import "~bulma/sass/utilities/mixins"
@import '~@/assets/sass/variables'
.social-media-buttons
    position: absolute
    right: 0
    top: 1.5rem
    display: flex
    flex-direction: column
    z-index: 25
    align-items: flex-end
    +mobile
        position: relative
        width: 100%
        right: unset
        flex-direction: row
        top: 0
        align-items: flex-start
    +touch
        position: relative
        width: 100%
        right: unset
        flex-direction: row
        top: 0
        align-items: flex-start
    a.button
        margin-left: 2px
        margin-top: 2px
        // margin-top: 1px
        // &:last-child
        //     margin-right: 2px
        &.facebook, &.twitter, &.instagram
            background-color: $primary
            color: #fff
            width: 65px
            height: 65px
            svg
                height: 25px
                width: 25px
        &.calendar
            width: 85px
            height: 85px
            background-color: #1e8dd2
            color: #fff
            display: flex
            flex-direction: column
            margin-bottom: 10px
            span
                margin-top: 5px
            svg
                height: 30px
                width: 30px
</style>
